/*
 * 动态加载 js/css 文件的方法
 * 返回 promise 对象
 */

export function loadStyle(url) {
  if (!url) {
    throw new Error('argument "url" is required !');
  }
  return new Promise(function (resolve, reject) {
    var link = document.createElement('link');
    link.dataset.initiator = 'cn-lowcode-page';
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.addEventListener('load', function () {
      return resolve(link);
    });
    link.addEventListener('error', reject);
    document.head.appendChild(link);
    return link;
  });
}
export function loadScript(url) {
  if (!url) {
    throw new Error('argument "url" is required !');
  }
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.dataset.initiator = 'cn-lowcode-page';
    script.crossOrigin = 'anonymous';
    // Dynamic scripts behave as “async” by default. https://javascript.info/script-async-defer#dynamic-scripts
    script.async = false;
    script.defer = true;
    script.src = url;
    script.addEventListener('load', function () {
      return resolve(script);
    });
    script.addEventListener('error', reject);
    document.body.appendChild(script);
    return script;
  });
}
export default {
  loadStyle: loadStyle,
  loadScript: loadScript
};